module.exports = __webpack_public_path__ + "ba829ba515b8d1a5fc4cdf460c686dc9.png";